/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  label: {
    width: 19,
    height: 12,
    viewBox: '0 0 19 12',
    data:
      '<path pid="0" d="M12.088 4.966a1.06 1.06 0 0 0-.746.302 1.02 1.02 0 0 0 0 1.463 1.072 1.072 0 0 0 1.492 0 1.02 1.02 0 0 0 0-1.463 1.059 1.059 0 0 0-.746-.302zm0 3.101c-.54 0-1.08-.202-1.491-.605A2.033 2.033 0 0 1 9.979 6c0-.552.219-1.07.618-1.462a2.142 2.142 0 0 1 2.983 0 2.043 2.043 0 0 1 0 2.925 2.125 2.125 0 0 1-1.492.605zM1.318 1.033a.265.265 0 0 0-.263.26v9.414c0 .14.12.26.263.26h11.098c.294 0 .769-.194.978-.398l4.475-4.386a.259.259 0 0 0 0-.366l-4.476-4.386c-.208-.204-.683-.398-.977-.398H1.318zM12.416 12H1.318C.59 12 0 11.42 0 10.707V1.293C0 .58.59 0 1.318 0h11.098c.575 0 1.316.3 1.723.7l4.475 4.386a1.275 1.275 0 0 1 0 1.828L14.139 11.3c-.408.4-1.148.7-1.723.7z" _fill="#000" fill-rule="evenodd"/>'
  }
})
